import React, { useMemo, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { blogPosts } from '../../data/blogPosts.jsx'
import { Clock, ArrowLeft } from 'lucide-react'
import BlogList from '../../components/Blog/BlogList'
import NewsletterCTA from '../../components/About/NewsletterCTA'
import Footer from '../../components/landing/Footer'
import GuestNavbar from '../../components/navigations/GuestNavbar'
export default function BlogRead() {
  const { id } = useParams()
  useEffect(()=>{ window.scrollTo(0,0); },[])
  useEffect(()=>{ window.scrollTo(0,0); },[id])

  const post = useMemo(() => blogPosts.find(p => p.id === id), [id])
  const popular = useMemo(() => {
    if (!post) return []
    return blogPosts.filter(p => p.id !== post.id).slice(0, 4)
  }, [post])
  const related = useMemo(() => {
    if (!post) return []
    const sameTopic = blogPosts.filter(p => p.topic === post.topic && p.id !== post.id)
    if (sameTopic.length >= 3) return sameTopic.slice(0, 3)
    const fillers = blogPosts.filter(p => p.id !== post.id && !sameTopic.includes(p)).slice(0, 3 - sameTopic.length)
    return [...sameTopic, ...fillers]
  }, [post])
  if (!post) {
    return (
      <div className="px-6 py-20 mx-auto max-w-4xl">
        <Link to="/blog" className="inline-flex gap-2 items-center text-emerald-700">
          <ArrowLeft size={16} /> Back to blog
        </Link>
        <h1 className="mt-6 text-xl font-semibold">Post not found</h1>
      </div>
    )
  }

  return (
    <>
    <GuestNavbar/>
      <article className="pt-0 pb-24">
      {/* Header */}
      <section className="relative py-16 bg-emerald-50">
        <div className="px-6 mx-auto max-w-5xl">
          <button type="button" onClick={() => window.history.back()} className="inline-flex gap-2 items-center text-emerald-700 hover:underline">
            <ArrowLeft size={16} /> Back
          </button>
          <h1 className="mt-3 text-2xl font-extrabold text-gray-900 sm:text-3xl">{post.title}</h1>
          <div className="flex gap-2 items-center mt-2 text-[11px] text-emerald-700">
            <span>Published — {post.date}</span>
            <span className="w-1 h-1 bg-emerald-600 rounded-full" />
            <span className="inline-flex gap-1 items-center"><Clock size={12} />{post.minutes} min read</span>
          </div>
        </div>
      </section>

      {/* Content + Sidebar */}
      <div className="grid grid-cols-1 gap-8 px-6 mx-auto mt-6 max-w-5xl lg:grid-cols-3">
        {/* Main */}
        <div className="lg:col-span-2">
          <div className="overflow-hidden rounded-xl">
            <img src={post.image} alt={post.title} className="w-full h-[320px] object-cover sm:h-[380px]" />
          </div>
          <div className="mt-6 max-w-none prose prose-emerald">
            {post.content?.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <p className="mt-6 text-xs text-gray-600">
            Good or bad, we’d love to hear your thoughts. Find us on Twitter
            <button type="button" className="ml-1 text-emerald-700 underline">@tripsecure</button>
          </p>
        </div>

        {/* Sidebar */}
        <aside className="lg:col-span-1">
          <div className="sticky top-24">
            <h3 className="text-xs font-bold tracking-wide text-gray-900 uppercase">Popular posts</h3>
            <div className="mt-4 space-y-4">
              {popular.map(pp => (
                <Link key={pp.id} to={`/blog/${pp.id}`} className="flex gap-3 items-start group">
                  <div className="overflow-hidden flex-shrink-0 w-20 h-14 rounded-md">
                    <img src={pp.image} alt={pp.title} className="object-cover w-full h-full" />
                  </div>
                  <div>
                    <div className="text-[11px] text-gray-500">{pp.date}</div>
                    <div className="mt-1 text-xs font-semibold leading-snug text-gray-900 group-hover:underline line-clamp-2">{pp.title}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>

      {/* Related posts */}
      <section className="px-6 mx-auto mt-12 max-w-5xl">
        <h3 className="text-lg font-extrabold text-gray-900">Related posts</h3>
        <div className="mt-4">
          <BlogList posts={related} />
        </div>
      </section>
    </article>
    <NewsletterCTA/>
    <Footer/>
    </>
  )
}


